module.exports = __webpack_public_path__ + "img/mb-econocard.4da1d39e.png";